//Almacenar la confifuración que tenga el ambiente de desarrollo

export const environment = {
  production: false,
  AMBIENTE: 'dev',

  //SSO
  URL_KEYCLOAK: 'https://dev-login.minambiente.gov.co',
  CLIENT_ID_KEYCLOAK: 'cima-ui',
  REALM_KEYCLOAK: 'ambiente',

  //URL JSON
  URL_JSON: 'https://api.jsonbin.io/v3/b/',

  //API POWERBI
  API_TOKEN_POWERBI_URL: 'https://6lheqecnc8.execute-api.us-east-1.amazonaws.com/v1/obtener-token-terraform',

};
